import React, { createContext, useContext, useRef } from 'react';

// 1. Create the Context
// We initialize with null, but the Provider will supply the actual ref object.
const CesiumViewerContext = createContext(null);

// 2. Create the Provider Component
export const CesiumViewerProvider = ({ children }) => {
  // Create the ref that will hold the viewer instance
  const viewerRef = useRef(null);

  // The value provided by the context is the ref object itself.
  // Components consuming the context will get this ref object.
  // MapViewPage will assign viewerRef.current when the Viewer mounts.
  const value = { viewerRef };

  return (
    <CesiumViewerContext.Provider value={value}>
      {children}
    </CesiumViewerContext.Provider>
  );
};

// 3. Create the Custom Hook
export const useCesiumViewer = () => {
  const context = useContext(CesiumViewerContext);
  if (context === null) {
    // This error means a component tried to use the context
    // without being wrapped in the Provider.
    throw new Error('useCesiumViewer must be used within a CesiumViewerProvider');
  }
  // Return the ref object provided by the context
  return context.viewerRef;
};

// Optional: Export the context itself if needed for advanced cases, but usually the hook is sufficient.
// export { CesiumViewerContext };